module.exports = __webpack_public_path__ + "img/lessons2.1c5d42d9.png";